// Aufrufe der Kommunikations-Routen (crm/API.md, Abschnitt 16). Eigener Client im Ordner, damit die gemeinsamen
// API-Dateien unberührt bleiben.
import type { Aktivitaet } from "../api";
import { http } from "../api/client";
import type {
  EmailErgebnis,
  EmailEingabe,
  EmailSenden,
  EmailVorschau,
  KommunikationsStatus,
  KontoEingabe,
  KontoStatus,
  Pruefung,
  SmsEingabe,
  SmsErgebnis,
  SmsSenden,
  SmsStand,
  SmsVorschau,
  Vorlage,
  VorlageEingabe,
  VorlagenFilter,
  VorlagenImport,
} from "./typen";

const kodiert = encodeURIComponent;

export const komm = {
  status: () => http.get<KommunikationsStatus>("/api/kommunikation/status"),
  smsWegSetzen: (sms_weg: "close" | "twilio") => http.put<KommunikationsStatus>("/api/kommunikation/einstellungen", { sms_weg }),
  planenFreigabe: (aktiv: boolean) => http.put<KommunikationsStatus>("/api/kommunikation/einstellungen", { senden_planen_freigabe: aktiv }),

  konto: () => http.get<{ konto: KontoStatus }>("/api/kommunikation/konto"),
  kontoSpeichern: (e: KontoEingabe) => http.put<{ konto: KontoStatus }>("/api/kommunikation/konto", e),
  kontoEntfernen: () => http.del<{ konto: KontoStatus }>("/api/kommunikation/konto"),
  kontoPruefen: () => http.post<{ konto: KontoStatus }>("/api/kommunikation/konto/pruefen"),
  testmail: () => http.post<{ testmail: { an: string; von: string; abgelegt: boolean; ablage_fehler: string | null } }>("/api/kommunikation/konto/testmail"),

  vorlagen: (art?: "email" | "sms", p: { status?: VorlagenFilter; q?: string } = {}) =>
    http.get<{ data: Vorlage[] }>("/api/kommunikation/vorlagen", { art, status: p.status, q: p.q }),
  vorlage: (id: string) => http.get<{ vorlage: Vorlage }>(`/api/kommunikation/vorlagen/${kodiert(id)}`),
  vorlagenImport: () => http.post<{ import: VorlagenImport; data: Vorlage[] }>("/api/kommunikation/vorlagen/import"),
  vorlageAnlegen: (v: VorlageEingabe & { art: "email" | "sms"; name: string; body: string }) =>
    http.post<{ vorlage: Vorlage }>("/api/kommunikation/vorlagen", v),
  vorlageAendern: (id: string, v: VorlageEingabe) => http.patch<{ vorlage: Vorlage }>(`/api/kommunikation/vorlagen/${kodiert(id)}`, v),
  vorlageLoeschen: (id: string) => http.del<void>(`/api/kommunikation/vorlagen/${kodiert(id)}`),
  vorlageDuplizieren: (id: string) => http.post<{ vorlage: Vorlage }>(`/api/kommunikation/vorlagen/${kodiert(id)}/duplizieren`),

  pruefung: (leadId: string, kanal: "email" | "sms") =>
    http.get<Pruefung>(`/api/kommunikation/leads/${kodiert(leadId)}/pruefung`, { kanal }),

  emailVorschau: (e: EmailEingabe) => http.post<EmailVorschau>("/api/kommunikation/email/vorschau", e),
  emailSenden: (e: EmailSenden) => http.post<EmailErgebnis>("/api/kommunikation/email/senden", e),
  smsVorschau: (e: SmsEingabe) => http.post<SmsVorschau>("/api/kommunikation/sms/vorschau", e),
  smsSenden: (e: SmsSenden) => http.post<SmsErgebnis>("/api/kommunikation/sms/senden", e),
  smsStand: (activityId: string) => http.get<SmsStand>(`/api/kommunikation/sms/${kodiert(activityId)}/status`),
  nachClose: (activityId: string) =>
    http.post<{ activity: Aktivitaet }>(`/api/kommunikation/aktivitaeten/${kodiert(activityId)}/nach-close`),
};
